@if (!ready) {
  <section>
    <app-spinner></app-spinner>
  </section>
} @else {
  <section>
    <h1>
      @if (request.mode !== 'years') {
        <span class="backlinks">
          <ng-container>
            <a routerLink="/archive">Archive</a> &raquo;
          </ng-container>
          @if (request.year && request.mode !== 'year') {
            <a routerLink="/archive/{{request.year}}">{{request.year}}</a>
            &raquo;
          }
          @if (request.month && request.mode !== 'month') {
            <a routerLink="/archive/{{request.year}}-{{digits(request.month)}}">
              {{request.date | dateAsUTC | date: 'MMMM'}}
            </a>
            &raquo;
          }
        </span>
      }
      @if (request.mode !== 'years') {
        <span class="mobile-back">
          @if (request.mode === 'year') {
            <a mat-button routerLink="/archive/years"><mat-icon>chevron_left</mat-icon> Years</a>
          }
          @if (request.mode === 'month') {
            <a mat-button routerLink="/archive/{{request.year}}"><mat-icon>chevron_left</mat-icon> {{request.year}}</a>
          }
          @if (request.mode === 'date') {
            <a mat-button routerLink="/archive/{{monthStringFor(request.date)}}"><mat-icon>chevron_left</mat-icon> {{request.date | dateAsUTC | date: 'MMMM'}}</a>
          }
        </span>
      }
      @if (request.mode === 'years') {
        Archive
      }
      @if (request.mode === 'year') {
        {{ request.year }}
      }
      @if (request.mode === 'month') {
        {{request.date | dateAsUTC | date: 'MMMM'}}
      }
      @if (request.mode === 'date') {
        {{request.date | date: 'fullDate'}}
      }
    </h1>
    @if (request.mode === 'years') {
      <p>Choose a year to see the content we have available.</p>
      <div class="years">
        @for (year of years; track year) {
          <a mat-button routerLink="/archive/{{year.year}}">{{year.year}}</a>
        }
      </div>
    }
    @if (request.mode === 'year') {
      <p>Choose a month to see the content we have available.</p>
      <div class="year">
        @for (month of months; track month) {
          <a mat-button routerLink="/archive/{{month.month}}">
            {{month.month | dateAsUTC | date: 'MMMM'}}
          </a>
        }
      </div>
    }
    @if (request.mode === 'month') {
      <div class="calendar">
        <div class="nav-buttons">
          <a routerLink="{{lastMonthUrl}}" mat-raised-button color="primary" aria-label="Previous Month">
            <mat-icon>arrow_back</mat-icon>
            <span class="label">Previous</span>
          </a>
          <div class="spacer"></div>
          <a routerLink="{{nextMonthUrl}}" mat-raised-button color="primary" aria-label="Next Month">
            <mat-icon>arrow_forward</mat-icon>
            <span class="label">Next</span>
          </a>
        </div>
        @if (!days || days.length == 0) {
          <div class="no-content" style="width: 100%;">
            <app-spinner></app-spinner>
          </div>
        }
        <div style="width:100%;">
          <p>Choose a day to see the content we have available on TYT.com</p>
        </div>
        @for (day of days; track day) {
          <div class="day">
            @if (day.date) {
              <div class="day-content" [class.has-episode]="day.episode">
                <span class="date">{{day.date.getDate()}}</span>
                <div class="show-list">
                  @for (show of day.shows; track show) {
                    @if (show && show.logo_square) {
                      <div class="avatar" [responsiveBackgroundImage]="show.logo_square"></div>
                    }
                  }
                </div>
                <a routerLink="{{day.url}}"></a>
              </div>
            }
          </div>
        }
      </div>
    }
    @if (request.mode === 'date') {
      <div class="day-overlay">
        @if (selectedDay) {
          <div>
            <div class="nav-buttons">
              <a routerLink="{{selectedDay.lastDayUrl}}" mat-raised-button color="primary" >
                <mat-icon>arrow_left</mat-icon>
                <span class="label">Previous Day</span>
              </a>
              <div class="spacer"></div>
              <a routerLink="{{selectedDay.nextDayUrl}}" mat-raised-button color="primary" >
                <mat-icon>arrow_right</mat-icon>
                <span class="label">Next Day</span>
              </a>
            </div>
            <div>
              <a class="mode-link" [class.active]="mode == 'episodes'" href="javascript:;"
              (click)="mode = 'episodes'">Episodes</a> |
              <a class="mode-link" [class.active]="mode == 'clips'" href="javascript:;" (click)="mode = 'clips'">Clips</a> |
              <a class="mode-link" [class.active]="mode == 'podcasts'" href="javascript:;"
              (click)="mode = 'podcasts'">Podcasts</a>
            </div>
            @if (!selectedDay.episodes) {
              <div>
                <app-spinner></app-spinner>
              </div>
            }
            @if (selectedDay.episodes) {
              <div class="episode-list">
                @for (production of selectedDay.episodes; track production) {
                  <tyt-production-view
                    [includeShowName]="true"
                    [production]="production"
                  [mode]="mode"></tyt-production-view>
                }
                @if (selectedDay.episodes.length == 0) {
                  <div>
                    <em>No archived content for this day.</em>
                  </div>
                }
                @if (isDeepArchive) {
                  <br /><br />
                  <h1>Check the Deep Archive</h1>
                  <p>Not all of our content has been imported into our new archive.
                    You can check our <a target="_blank" href="{{deepArchiveLink}}">legacy archive</a> for this day
                    as well.
                  </p>
                }
              </div>
            }
          </div>
        }
      </div>
    }
    <br />
    <br />
    <h1>Past Shows</h1>
    @for (show of pastShows; track show) {
      <a routerLink="/shows/{{ show.slug ?? show.id }}">{{ show.name }}</a><br />
    }
    <br />
    <h1>Additional Archives from TYTNetwork.com</h1>
    <div class="archived-shows">
      <a target="_blank" href="https://legacy.tyt.com/category/membership/main-show-hour-1/">The Young Turks Hour
      1</a><br />
      <a target="_blank" href="https://legacy.tyt.com/category/membership/main-show-hour-2/">The Young Turks Hour
      2</a><br />
      <a target="_blank" href="https://legacy.tyt.com/category/membership/post-game/">Post Game</a><br />
      <a target="_blank" href="https://legacy.tyt.com/category/membership/tyt-old-school-on-demand/">TYT Old
      School</a><br />
      <a target="_blank" href="https://legacy.tyt.com/category/membership/nerd-alert-on-demand/">Nerd Alert</a><br />
      <a target="_blank" href="https://legacy.tyt.com/category/membership/what-the-flick-on-demand/">What the
      Flick?!</a><br />
      <a target="_blank" href="https://legacy.tyt.com/category/murder-with-friends/">Murder With Friends</a><br />
      <a target="_blank" href="{{deepArchiveLink}}">Deep Archive</a>
    </div>
  </section>
}